/*
 * A segmented control's segments (Grid/List, 24 hours/7 days, Unread/All). The selected one is "where you are":
 * the brand as a solid fill, with text computed to read on it (styles.css --hx-brand-solid and --hx-on-brand),
 * the same as the active environment tab. The others stay quiet gray text.
 */
export const SEGMENT_ON = "bg-brand-solid text-on-brand shadow-[0_1px_2px_rgba(15,23,42,0.14)]";
export const SEGMENT_OFF = "text-dim hover:text-fg";
